define([
    "jquery",
    "underscore",
    "marionette",
    "views/profile/common_info_view",
    "behaviors/form_errors_behavior",
    "jquery.fileupload",
    "backbone.syphon",
    "holdon"
], function($, _, Marionette, ProfileCommonView, FormErrorsBehavior) {
    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        initialize: function(){
            this.bindUIElements();

            new ProfileCommonView();

            $('[data-toggle="popover"]').popover();
        },

        submit: function(type){
            var that = this;

            HoldOn.open({
                theme: "sk-fading-circle"
            });

            var formData = Backbone.Syphon.serialize(this);
            var form = this[type+'Form'];

            form.set(formData);

            var errors = form.validate();

            if(_.size(errors) < 1){
                form.validateWithServer({
                    type: 'POST',
                    success: function(model, res){
                        that.ui[type+'Form'].submit();
                    },
                    error: function(model, error){
                        HoldOn.close();
                        that.triggerMethod('show:errors', error.responseJSON);
                    }
                });
            }else{
                HoldOn.close();
                this.triggerMethod('show:errors', errors);
            }
        },

        initFileUpload: function($selector, type){
            var that = this;
            $selector.fileupload({
                url: '/rest_profile/'+that.toUnderscore(type),
                dataType: 'json',
                dropZone: that.ui[type + 'Form'],
                // File selected, put the original name in the textbox
                add: function(e, data){
                    HoldOn.open({
                        theme:"sk-fading-circle"
                    });
                    data.submit();
                },
                // Upload success, put the server-side name in the hidden input
                done: function(e, data){
                    HoldOn.close();

                    that.ui[type+'Name'].val(data.files[0].name).trigger('change');
                    that.ui[type].val(data.jqXHR.responseJSON.file_path);
                    if(that.ui[type+'Preview']){
                        that.ui[type + 'Preview'].attr('src', '/common/show_tmp_document?file=' + data.jqXHR.responseJSON.file_path);
                        that.ui[type + 'Collapse'].collapse('show');
                    }
                },
                // Upload failed, display error + remove name from textbox
                fail: function(e,data){
                    HoldOn.close();
                    var errors = {};
                    // CamelCase to under_score
                    errors[that.toUnderscore(type)] = data.jqXHR.responseJSON.error_msg;

                    that.ui[type+'Name'].val('').trigger('change');
                    that.ui[type].val('');

                    that.triggerMethod('show:errors', errors);
                }
            });
        },

        initLegalFileUpload: function($selector, type){
            var that = this;
            $selector[0].addEventListener('change', function (e){
                that.ui[type+'Name'].val(e.srcElement.files[0].name).trigger('change');
                that.ui[type].val(e.srcElement.files[0].name);
            })
        },

        toUnderscore: function(string){
            return string.replace(/([A-Z])/g, function($1){return "_"+$1.toLowerCase();});
        }
    });
});
